import baseStyles from '../sass/base.scss';
let commons = require('./utils/commons');
import mobileMenuJS from './includes/mobile_menu.js';
import cityModalJS from './includes/city_modal.js';
import consultationModalJS from './includes/consultation_modal.js';
import floatingHeaderJs from './includes/floating_header.js';
import logoImg from '../img/logo.png';
import mailIconImg from '../img/mail-icon.png';
import phoneIconImg from '../img/phone-icon.png';
import logoWhiteImg from '../img/logo-white.png';
import socialsFacebookImg from '../img/socials-facebook.png';
import socialsYoutubeImg from '../img/socials-youtube.png';
import socialsVimeoImg from '../img/socials-vimeo.png';
import socialsTwitterImg from '../img/socials-twitter.png';
import closeMenuIconImg from '../img/close-menu-icon.png';
import closeBlackIconImg from '../img/close-black-icon.png';
import upButtonImg from '../img/up-button.png';
var smoothScroll = require('smooth-scroll');

var scroll = smoothScroll('a[href*="#"]');
